<div id="tour-dashboard-pc" class="card">
  <div class="card__title">
    Peer Comparison
    @if(productState().hasPeerComparison){
    <a class="card__title-link" routerLink="/peer-comparison">Go to Product</a>
    }
  </div>
  <div class="card__content card__content--grid">
    <div id="tour-dashboard-links" class="kpi kpi--name">
      <div class="kpi__quick">
        <div class="kpi__quick-title">Quick Links</div>

         <!-- Logic for modal when clicked  -->
        <a class="kpi__quick-link" (click)="navigate('/peer-comparison/balance/snapshot')">Balance Sheet</a>
        <a class="kpi__quick-link" (click)="navigate('/peer-comparison/correlations')">Correlations</a>
        <a class="kpi__quick-link" (click)="navigate('/peer-comparison/quarterly')">Quarterly Summary</a>
        <a class="kpi__quick-link" (click)="navigate('/peer-comparison/groups')">Peer Groups</a>

      </div>
    </div>
    <app-kpi-score (click)="navigate('/peer-comparison/performance/liquidity')"
      [metricId]="getMetricId('LHAC0030', 'LHAC_0030')" title="Liquidity Score"></app-kpi-score>
    <app-kpi-score id="tour-dashboard-profitability" (click)="navigate('/peer-comparison/performance/profitability')"
      [metricId]="getMetricId('LHAC0031', 'LHAC_0031')" title="Profitability Score"></app-kpi-score>
    <app-kpi-score (click)="navigate('/peer-comparison/performance/capital')"
      [metricId]="getMetricId('LHAC0032', 'LHAC_0032')" title="Capital Score"></app-kpi-score>
    <app-kpi-score (click)="navigate('/peer-comparison/performance/revenue')"
      [metricId]="getMetricId('LHAC0033', 'LHAC_0033')" title="Revenue and Expense Score"></app-kpi-score>
    <app-kpi-score (click)="navigate('/peer-comparison/performance/credit')"
      [metricId]="getMetricId('LHAC0034', 'LHAC_0034')" title="Credit Score"></app-kpi-score>
    <div class="kpi-key">
      <span>Low</span><span>Below Average</span><span>Average</span><span>Above Average</span><span>High</span>
    </div>
    <div class="kpi-key-desc expand" [ngClass]="{ 'expand--expanded': showMore() }">
      <p>The values above describe your performance as of {{ reportDate() | date: 'LLL yyyy' }} in comparison to savings
        and commercial banks with a similar asset size.</p>
      <div class="expand__more">
        <p>The ranks are composites of key performance indicators (KPIs) within each performance category. In the rank
          calculation, the KPI values for members of your VBC National Peer Group are sorted into quintiles and assigned
          a KPI score from 1 to 5 with the best values receiving a score of 5. The position reported on the dashboard is
          a weighted average of the KPI scores for your bank. Click the rank value on the dashboard to see the
          individual KPIs along with your historical performance compared to your peers.</p>
      </div>
      <a (click)="showMore.set(true)" class="expand__link expand__link--more">
        Learn More
        <svg class="icon expand__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
          <path
            d="M169.4 278.6C175.6 284.9 183.8 288 192 288s16.38-3.125 22.62-9.375l160-160c12.5-12.5 12.5-32.75 0-45.25s-32.75-12.5-45.25 0L192 210.8L54.63 73.38c-12.5-12.5-32.75-12.5-45.25 0s-12.5 32.75 0 45.25L169.4 278.6zM329.4 265.4L192 402.8L54.63 265.4c-12.5-12.5-32.75-12.5-45.25 0s-12.5 32.75 0 45.25l160 160C175.6 476.9 183.8 480 192 480s16.38-3.125 22.62-9.375l160-160c12.5-12.5 12.5-32.75 0-45.25S341.9 252.9 329.4 265.4z" />
        </svg>
      </a>
      <a (click)="showMore.set(false)" class="expand__link expand__link--less">
        Show Less
        <svg class="icon expand__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
          <path
            d="M54.63 246.6L192 109.3l137.4 137.4C335.6 252.9 343.8 256 352 256s16.38-3.125 22.62-9.375c12.5-12.5 12.5-32.75 0-45.25l-160-160c-12.5-12.5-32.75-12.5-45.25 0l-160 160c-12.5 12.5-12.5 32.75 0 45.25S42.13 259.1 54.63 246.6zM214.6 233.4c-12.5-12.5-32.75-12.5-45.25 0l-160 160c-12.5 12.5-12.5 32.75 0 45.25s32.75 12.5 45.25 0L192 301.3l137.4 137.4C335.6 444.9 343.8 448 352 448s16.38-3.125 22.62-9.375c12.5-12.5 12.5-32.75 0-45.25L214.6 233.4z" />
        </svg>
      </a>
    </div>
  </div>
</div>